module.exports = __webpack_public_path__ + "img/snow.5a4d5c56.svg";